import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BUDGET_TABS } from '../../../screens/ModalBudget/utils/enum';
import { supabase } from '../../../supabaseClient';
import './styles.scss';
import { AuthorizationTerm } from './tabs/AuthorizationTerm';
import { FixedChecklist } from './tabs/FixedChecklist';
import { ImageRegister } from './tabs/ImageRegister';

const tabChecklists = {
  IMAGE_REGISTER: 1,
  FIXED_CHECKLIST: 2,
  AUTHORIZATION_TERM: 3,
};

export const OSEntryChecklist = (props) => {
  const company = useSelector((state) => state.app.company || {});
  const {
    budget,
    onChange,
    values,
    printCompany,
    localSignatureData,
    setLocalSignatureData,
    isSignatureReset,
    setIsSignatureReset,
    onSaveBeforeSignature,
  } = props;
  const [currentTab, setCurrentTab] = useState(tabChecklists.IMAGE_REGISTER);
  const [checklistData, setChecklistData] = useState([]);

  async function loadFixedChecklist() {
    const { data, error: fetchError } = await supabase
      .from('CompanyChecklist')
      .select('name, id')
      .eq('company_id', company.id);

    if (!fetchError) {
      setChecklistData(data);
    }
  }

  useEffect(() => {
    if (company.id) {
      loadFixedChecklist();
    }
  }, []);

  if (budget !== BUDGET_TABS.ENTRY_CHECKLIST) {
    return;
  }

  return (
    <div className="os-notes-container">
      <div className="os-notes-tabs-container">
        <div
          onClick={() => setCurrentTab(tabChecklists.IMAGE_REGISTER)}
          className={`os-notes-button-tabs ${
            currentTab === tabChecklists.IMAGE_REGISTER
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Registro por imagem
        </div>
        <div
          onClick={() => setCurrentTab(tabChecklists.FIXED_CHECKLIST)}
          className={`os-notes-button-tabs ${
            currentTab === tabChecklists.FIXED_CHECKLIST
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Checklist
        </div>

        <div
          onClick={() => setCurrentTab(tabChecklists.AUTHORIZATION_TERM)}
          className={`os-notes-button-tabs ${
            currentTab === tabChecklists.AUTHORIZATION_TERM
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Termo de autorização
        </div>
      </div>

      {currentTab === tabChecklists.IMAGE_REGISTER && (
        <ImageRegister onChange={onChange} values={values} />
      )}

      {currentTab === tabChecklists.FIXED_CHECKLIST && (
        <FixedChecklist
          onChange={onChange}
          values={values}
          checklistData={checklistData}
        />
      )}
      {currentTab === tabChecklists.AUTHORIZATION_TERM && (
        <AuthorizationTerm
          company={company}
          printCompany={printCompany}
          onChange={onChange}
          values={values}
          localSignatureData={localSignatureData}
          setLocalSignatureData={setLocalSignatureData}
          isSignatureReset={isSignatureReset}
          setIsSignatureReset={setIsSignatureReset}
          onSaveBeforeSignature={onSaveBeforeSignature}
        />
      )}
    </div>
  );
};
